var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustryMinerals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-1024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-details",
    transform: "translate(-544.000000, -131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diamond",
    transform: "translate(544.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#07575B",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0478609,14.1946477 L11.8422344,8.25896094 L11.8422344,8.25896094 L8.15776562,8.25896094 L9.95213912,14.1946477 C9.96012984,14.2210805 9.98803564,14.2360308 10.0144685,14.2280401 C10.0304856,14.223198 10.0430189,14.2106648 10.0478609,14.1946477 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "8.10071875 7.56134375 11.8992812 7.56134375 11.2790781 5.01192969 8.72092187 5.01192969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6172422,7.56134375 L15.8990451,7.56134375 C15.9266594,7.56134375 15.9490451,7.53895799 15.9490451,7.51134375 C15.9490451,7.50039552 15.9454517,7.48974991 15.9388166,7.48104138 L14.1622656,5.14934375 L14.1622656,5.14934375 C14.0962891,5.06276562 13.9936797,5.01192969 13.8848125,5.01192969 L11.9970391,5.01192969 L12.6172422,7.56134375 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38275781,7.56134375 L8.00296094,5.01192969 L6.1151875,5.01192969 C6.00632031,5.01192969 5.90371094,5.06274219 5.83773438,5.14934375 L4.06118343,7.48104138 C4.04444789,7.50300653 4.04868733,7.53437964 4.07065248,7.55111518 C4.07936101,7.55775032 4.09000663,7.56134375 4.10095485,7.56134375 L7.38275781,7.56134375 L7.38275781,7.56134375 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,8.26 L7.42897656,8.26 L9.60632338,15.4585138 C9.61431819,15.4849454 9.59937222,15.5128535 9.57294063,15.5208484 C9.5529662,15.5268901 9.53134015,15.5198911 9.51869315,15.5032919 L4,8.26 L4,8.26 Z",
    id: "Path-28",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5710234,8.26 L16,8.26 L10.5087881,15.5035669 C10.4921059,15.5255726 10.4607432,15.5298883 10.4387375,15.5132061 C10.4221235,15.5006114 10.4150681,15.4790297 10.4210341,15.4590532 L12.5710234,8.26 L12.5710234,8.26 Z",
    id: "Path-29",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryMinerals);
export default __webpack_public_path__ + "static/media/industry-minerals.9fb859e4.svg";
export { ForwardRef as ReactComponent };